import { useQuery, UseQueryResult } from 'react-query';
import apiFetch, { defaultApiFetchErrorHandler, HTTPError } from 'react-scale/lib/api-fetch';
import { GetWorkerSkillsResult, WorkerSkillResponse } from '@scale/genai-data-service-client';

const filterDeprecated = (skills: WorkerSkillResponse[]): WorkerSkillResponse[] =>
  skills
    .filter(s => !s.deprecated)
    .map(s => ({
      ...s,
      childSkills: s.childSkills ? filterDeprecated(s.childSkills) : undefined,
    }));

export const useFetchAllWorkerSkills = (
  tree?: boolean,
  treeLevels?: number,
  onSuccess?: (res: WorkerSkillResponse[]) => void,
  options?: { enabled?: boolean },
): UseQueryResult<WorkerSkillResponse[], unknown> => {
  return useQuery(
    ['fetchAllWorkerSkills', tree, treeLevels],
    async () => {
      const response = await apiFetch<GetWorkerSkillsResult>(null, '/corp-api/worker-skills', {
        method: 'GET',
        query: {
          tree,
          treeLevels,
        },
      });

      return filterDeprecated(response.workerSkills);
    },
    {
      onSuccess,
      onError: (err: HTTPError) => defaultApiFetchErrorHandler(err, { handleHttp: true }),
      enabled: options?.enabled ?? false,
    },
  );
};
